import type {FC} from 'react'
import {memo} from 'react'
import {AnimatedCounterDigit} from '../AnimatedCounterDigit'
import type {TimeValues} from '../utils'

interface CountdownCounterProps {
  values: TimeValues
}

export const CountdownCounter: FC<CountdownCounterProps> = memo(({values}) => (
  <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-6" suppressHydrationWarning>
    {/* Years */}
    {values.years !== null && values.years !== undefined && (
      <>
        <AnimatedCounterDigit value={values.years} unit="y" />
        <div className="z-10 h-[6px] w-[6px] rounded-sm bg-[#d9d9d9] md:h-[10px] md:w-[10px]" />
      </>
    )}

    {/* Months */}
    {values.months !== null && values.months !== undefined && (
      <>
        <AnimatedCounterDigit value={values.months} unit="m" />
        <div className="z-10 h-[6px] w-[6px] rounded-sm bg-[#d9d9d9] md:h-[10px] md:w-[10px]" />
      </>
    )}

    {/* Days */}
    {values.days !== null && values.days !== undefined && (
      <>
        <AnimatedCounterDigit value={values.days} unit="d" />
        <div className="z-10 h-[6px] w-[6px] rounded-sm bg-[#d9d9d9] md:h-[10px] md:w-[10px]" />
      </>
    )}

    {/* Hours */}
    {values.hours !== null && values.hours !== undefined && (
      <>
        <AnimatedCounterDigit value={values.hours} unit="h" />
        <div className="z-10 h-[6px] w-[6px] rounded-sm bg-[#d9d9d9] md:h-[10px] md:w-[10px]" />
      </>
    )}

    {/* Minutes */}
    {values.minutes !== null && values.minutes !== undefined && (
      <AnimatedCounterDigit value={values.minutes} unit="min" />
    )}
  </div>
))

CountdownCounter.displayName = 'CountdownCounter'
